import {
  createTaskerMessageConverter,
  TaskerMessage,
  createTaskerConfigConverter,
  TaskerConfig,
} from "@t3/shared";
import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  serverTimestamp,
} from "firebase/firestore";

export const taskerMessageConverter = createTaskerMessageConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<TaskerMessage, DocumentData>;

export const taskerConfigConverter = createTaskerConfigConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<TaskerConfig, DocumentData>;
